import { OfferLogHistory } from "./modals/offer-log-history";
import { OfferT } from "../../../domain";
import React from "react";
import {
  HistoryIcon,
  Modal,
  useDisclosure,
} from "../../../../../shared/infrastructure";

type OfferCardLogHistoryButtonProps = {
  offer: OfferT;
};

export const OfferCardLogHistoryButton = ({
  offer,
}: OfferCardLogHistoryButtonProps): React.ReactElement => {
  const { open, isOpen, close } = useDisclosure();

  return (
    <React.Fragment>
      <button
        className="flex h-5 w-5 cursor-pointer items-center justify-center rounded-[5px] border-0 bg-black p-0 text-center text-white md:flex md:h-[26px] md:w-[26px]"
        onClick={open}
      >
        <HistoryIcon />
      </button>
      <Modal
        open={isOpen}
        onClose={close}
        content={
          <OfferLogHistory
            carrier={offer.carrier}
            origin={offer.origin}
            destination={offer.destination}
          />
        }
        classNames={{
          content:
            "overflow-x-scroll overflow-y-hidden p-[20px] min-w-[1100px] max-h-[420px]",
          paper: "rounded-[5px] max-w-[85%]",
        }}
      />
    </React.Fragment>
  );
};
